document.addEventListener('DOMContentLoaded', function() {

  var flkty = null;

  function initFlickity() {
    if (flkty) { flkty.destroy(); flkty = null; }
    const el = document.querySelector('.builder-selected__product--image');
    if (!el) return;
    flkty = new Flickity(el, {
      wrapAround: false,
      prevNextButtons: false,
      pageDots: false,
      draggable: true,
      freeScroll: true,
      contain: true,
    });
  }

  // function reinitFlickityAndScroll(scrollToLast) {
  //   setTimeout(() => {
  //     initFlickity();
  //     if (scrollToLast && flkty) {
  //       const last = flkty.cells.length - 1;
  //       if (last >= 0) flkty.select(last, true, true);
  //     }
  //     checkTotalQty();
  //   }, 10);
  // }

  // function reinitFlickityAndScroll(scrollToLast, domChanged) {
  //   setTimeout(() => {
  //     if (domChanged || !flkty) {
  //       initFlickity();
  //     } else {
  //       flkty.reloadCells();
  //     }
  //     if (scrollToLast && flkty) {
  //       const last = flkty.cells.length - 1;
  //       if (last >= 0) flkty.select(last, true, true);
  //     }
  //     checkTotalQty();
  //   }, 10);
  // }

  // loader added flickity
  function reinitFlickityAndScroll(scrollToLast, domChanged) {
    const sliderEl = document.querySelector('.builder-selected__product--image');

    if (domChanged && sliderEl) {
      sliderEl.classList.add('is-reiniting');
    }

    setTimeout(() => {
      if (domChanged || !flkty) {
        initFlickity();
      } else {
        flkty.reloadCells();
      }

      if (scrollToLast && flkty) {
        const last = flkty.cells.length - 1;
        if (last >= 0) flkty.select(last, true, true);
      }

      checkTotalQty();

      if (domChanged && sliderEl) {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            sliderEl.classList.remove('is-reiniting');
          });
        });
      }
    }, 300);
  }

  initFlickity();

  function parseVariantJson(parentEle) {
    const el = parentEle.querySelector('[bundle-builder-variant-json]');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.warn('Could not parse variant JSON', e);
      return [];
    }
  }

  function updateProductSizes(parentEle) {
    const productVariants = parseVariantJson(parentEle);
    if (!productVariants.length) return;

    const sizeSelect  = parentEle.querySelector('.bundle-size-select');
    const styleSelect = parentEle.querySelector('.bundle-style-select');

    // products without size option 
    if (!sizeSelect) {

      const firstAvail = productVariants.find(v => v.available);
      const chosen     = firstAvail || productVariants[0];
      if (!chosen) { parentEle.classList.add('hidden'); return; }

      parentEle.classList.remove('hidden');
      updateCardImage(parentEle, chosen);
      updateAtcButton(parentEle, chosen);
      return;
    }

    const sizePosition = parseInt(sizeSelect.getAttribute('data-position'), 10);

    // Decide which variants are relevant filtered by current style if present
    let relevantVariants = productVariants;
    if (styleSelect) {
      const stylePosition = parseInt(styleSelect.getAttribute('data-position'), 10);
      const styleValue    = styleSelect.value;
      relevantVariants    = productVariants.filter(
        v => (v[`option${stylePosition}`] || '').toLowerCase() === styleValue.toLowerCase()
      );
    }

    const originalSizeValue = sizeSelect.value;
    sizeSelect.options.length = 0;

    const addedOptions      = new Set();
    let firstAvailableVariant;
    let chosenVariant;

    for (const variant of relevantVariants) {
      const optionValue = variant[`option${sizePosition}`];
      if (!optionValue || addedOptions.has(optionValue)) continue;

      const opt      = document.createElement('option');
      opt.value      = optionValue;
      opt.textContent = optionValue;
      opt.disabled   = !variant.available;
      sizeSelect.appendChild(opt);

      if (
        originalSizeValue &&
        originalSizeValue.toLowerCase() === optionValue.toLowerCase() &&
        variant.available
      ) {
        chosenVariant    = variant;
        sizeSelect.value = opt.value;
      }

      if (variant.available && !firstAvailableVariant) firstAvailableVariant = variant;

      addedOptions.add(optionValue);
    }

    // Fall back to first available if stored selection is not valid
    if (!chosenVariant && firstAvailableVariant) {
      sizeSelect.value = firstAvailableVariant[`option${sizePosition}`];
      chosenVariant    = firstAvailableVariant;
    }

    if (!chosenVariant) {
      parentEle.classList.add('hidden');
      return;
    }

    parentEle.classList.remove('hidden');
    updateCardImage(parentEle, chosenVariant);
    updateAtcButton(parentEle, chosenVariant);
  }

  // helpers shared between updateProductSizes & onSelectBoxChange
  function updateCardImage(parentEle, variant) {
    const img = parentEle.querySelector('.bundle-builder__product--image img');
    if (!img) return;
    // guard against variants with no featured_image
    if (variant.featured_image && variant.featured_image.src) {
      img.setAttribute('src',    variant.featured_image.src);
      img.setAttribute('srcset', `${variant.featured_image.src}&width=380`);
    }
  }

  function updateAtcButton(parentEle, variant) {
    // use class selector id is duplicated across cards
    const atcBtn = parentEle.querySelector('.bundle-builder__atc-btn');
    if (!atcBtn) return;
    atcBtn.setAttribute('data-variant-id', variant.id);

    const styleSelect = parentEle.querySelector('.bundle_builder_product_option_select[name="style"]');
    const sizeSelect  = parentEle.querySelector('.bundle_builder_product_option_select[name="size"]');
    if (styleSelect) atcBtn.setAttribute('data-style',     styleSelect.value);
    if (sizeSelect)  atcBtn.setAttribute('data-shoe-size', sizeSelect.value);

    if (!variant.available) {
      atcBtn.textContent = 'Sold out';
      atcBtn.disabled    = true;
    } else {
      atcBtn.textContent = 'Add to bundle';
      atcBtn.disabled    = false;
    }
  }

  function onSelectBoxChange(selectBox) {
    const parentEle      = selectBox.closest('.bundle-builder__product--card');
    const productVariants = parseVariantJson(parentEle);
    if (!productVariants.length) return;

    const selectedOptions = Array.from(
      parentEle.querySelectorAll('.bundle_builder_product_option_select')
    ).map(sel => sel.value.trim());

    const matchedVariant = productVariants.find(variant => {
      if (!variant.options || variant.options.length !== selectedOptions.length) return false;
      return variant.options.every((opt, i) => opt.trim() === selectedOptions[i]);
    });

    if (matchedVariant) {
      console.log('Matched Variant:', matchedVariant);
      updateAtcButton(parentEle, matchedVariant);
      updateCardImage(parentEle, matchedVariant);
    } else {
      console.log('No matching variant found for selection:', selectedOptions);
    }
  }

  // attach change listeners to all option selects
  document.querySelectorAll('.bundle_builder_product_option_select').forEach(selectBox => {
    selectBox.addEventListener('change', () => onSelectBoxChange(selectBox));
  });

  // style change also re-filters the size dropdown
  document.querySelectorAll('.bundle-style-select').forEach(styleEl => {
    styleEl.addEventListener('change', () => {
      const parentEle = styleEl.closest('.bundle-builder__product--card');
      updateProductSizes(parentEle);
    });
  });

  // initialise all cards
  document.querySelectorAll('.bundle-builder__product--card').forEach(card => {
    updateProductSizes(card);
  });

  //  Build the selected-item HTML snippet 
  function buildSelectedItemHTML(variantId, qty, imgSrc, styleName, sizeName) {
    const variantLabel = [
      styleName ? `<span>Style: ${styleName}</span>` : '',
      sizeName  ? `<span>Size: ${sizeName}</span>`   : '',
    ].filter(Boolean).join('');

    return `<div class="builder_selected_product_item active"
              data-variant-id="${variantId}"
              data-variant-qty="${qty}">
      <div class="builder_selected_product_item_image">
        <img src="${imgSrc}" width="90" height="90" alt="Builder Image">
        <div class="builder-selected__image--cross cross">
          <svg xmlns="http://www.w3.org/2000/svg" class="icon-cross cross"
               width="17" height="16" viewBox="0 0 17 16" fill="none">
            <path class="cross"
              d="M13.1671 3.33325L3.83374 12.6666M3.83374 3.33325L13.1671 12.6666"
              stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>
      <div class="builder_selected_product_item_content">
        <div class="builder_selected_product_item_option">
          <span class="builder_selected_product_item_variant">${variantLabel}</span>
        </div>
        <div class="builder_selected_product_item_quantity">
          Qty: <span class="builder_selected_product_item_qty">${qty}</span>
        </div>
      </div>
    </div>`;
  }


  //  atc button click 
  document.querySelectorAll('.bundle-builder__btn').forEach(atcButton => {
    atcButton.addEventListener('click', () => {
      const parentEle      = atcButton.closest('.bundle-builder__product--card');
      const productVariants = parseVariantJson(parentEle);

      const selectedOptions = Array.from(
        parentEle.querySelectorAll('.bundle_builder_product_option_select')
      ).map(sel => sel.value.trim());

      // for products with no option selects, fall back to the variant-id
      // already stored on the button set by Liquid or by updateProductSizes.
      let matchedVariant = null;
      if (selectedOptions.length && productVariants.length) {
        matchedVariant = productVariants.find(variant => {
          if (!variant.options || variant.options.length !== selectedOptions.length) return false;
          return variant.options.every((opt, i) => opt.trim() === selectedOptions[i]);
        });
      }

      // use class-based atc button, not id
      const atcBtn   = parentEle.querySelector('.bundle-builder__atc-btn');
      const variantId = matchedVariant
        ? matchedVariant.id
        : (atcBtn ? parseInt(atcBtn.getAttribute('data-variant-id'), 10) : null);

      if (!variantId) {
        console.warn('❌ No variant ID available — cannot add to bundle.');
        return;
      }

      const qty        = parseInt(parentEle.querySelector('.bundle_builder_product_qty').value, 10) || 1;
      const imgSrc     = parentEle.querySelector('.bundle-builder__product--image img')?.getAttribute('src') || '';
      const styleValue = parentEle.querySelector('.bundle_builder_product_option_select[name="style"]')?.value || '';
      const sizeValue  = parentEle.querySelector('.bundle_builder_product_option_select[name="size"]')?.value  || '';

      if (matchedVariant) console.log('✅ Matched Variant ID:', variantId);
      else                console.log('ℹ️ Using fallback Variant ID:', variantId);

      // insert into bundle slot
      const bundleItems       = document.querySelectorAll('.builder_selected_product_item');
      let firstInactiveItem   = null;
      for (const item of bundleItems) {
        if (!item.classList.contains('active')) { firstInactiveItem = item; break; }
      }

      if (firstInactiveItem) {
        firstInactiveItem.classList.add('active');
        firstInactiveItem.setAttribute('data-variant-id',  variantId);
        firstInactiveItem.setAttribute('data-variant-qty', qty);
        firstInactiveItem.querySelector('.builder_selected_product_item_image img').src = imgSrc;

        const variantLabel = [
          styleValue ? `<span>Style: ${styleValue}</span>` : '',
          sizeValue  ? `<span>Size: ${sizeValue}</span>`   : '',
        ].filter(Boolean).join('');
        firstInactiveItem.querySelector('.builder_selected_product_item_variant').innerHTML = variantLabel;
        firstInactiveItem.querySelector('.builder_selected_product_item_qty').textContent   = qty;

        // reinitFlickityAndScroll(false);
        reinitFlickityAndScroll(false, false);
      } else {
        const htmlContent   = buildSelectedItemHTML(variantId, qty, imgSrc, styleValue, sizeValue);
        const selectedList  = document.querySelector('.builder-selected__product--image');
        if (selectedList) {
          if (flkty) { flkty.destroy(); flkty = null; }
          setTimeout(() => {
            selectedList.insertAdjacentHTML('beforeend', htmlContent);
            // reinitFlickityAndScroll(true);
            reinitFlickityAndScroll(true, true);
          }, 10);
        }
      }
    });
  });


  //  Total qty & checkout state 
  function checkTotalQty() {
    const selectedItems = document.querySelectorAll('.builder_selected_product_item.active');
    let totalQty = 0;
    selectedItems.forEach(item => {
      const q = parseInt(item.getAttribute('data-variant-qty'), 10);
      if (!isNaN(q)) totalQty += q;
    });

    const checkoutBtn   = document.querySelector('.bundle-builder__checkout button');
    const emailMsg      = document.querySelector('.bundle-builder__checkout-email');
    if (!checkoutBtn || !emailMsg) return;

    if (totalQty > 24) {
      checkoutBtn.style.display = 'none';
      emailMsg.style.display    = 'block';
    } else {
      emailMsg.style.display    = 'none';
      checkoutBtn.style.display = 'inline-block';
      checkoutBtn.disabled      = totalQty <= 4;
    }
  }


  // use closest() from event.target to handle SVG child element bubbling.
  document.addEventListener('click', event => {

    // remove item from bundle 
    // match the cross button or any of its SVG children
    const crossEl = event.target.closest('.cross');
    if (crossEl) {
      const parentElement = crossEl.closest('.builder_selected_product_item');
      if (!parentElement) return;

      const activeItems = document.querySelectorAll('.builder_selected_product_item.active');

      if (activeItems.length > 5) {
        // for more than the initial 5 fixed slots,  physically remove the extra card
        parentElement.remove();
        // reinitFlickityAndScroll(false);
        reinitFlickityAndScroll(false, true);

      } else {
        // reset the fixed slot back to placeholder state
        parentElement.classList.remove('active');
        parentElement.setAttribute('data-variant-id',  '');
        parentElement.setAttribute('data-variant-qty', '');
        const img = parentElement.querySelector('.builder_selected_product_item_image img');
        if (img) img.src = 'https://cdn.shopify.com/s/files/1/0611/8100/1946/files/builder-dummy.png?v=1760894913';
        const variantSpan = parentElement.querySelector('.builder_selected_product_item_variant');
        if (variantSpan) variantSpan.textContent = '';
        const qtySpan = parentElement.querySelector('.builder_selected_product_item_qty');
        if (qtySpan) qtySpan.textContent = '';
        checkTotalQty();
      }
      return;
    }

    // checkout
    if (!event.target.classList.contains('bundle-builder__checkout-btn')) return;

    const selectedItems = document.querySelectorAll('.builder_selected_product_item.active');
    const checkoutBtn   = document.querySelector('.bundle-builder__checkout-btn');
    if (!selectedItems.length) return;

    checkoutBtn.disabled    = true;
    checkoutBtn.textContent = 'Adding…';

    fetch('/cart/clear.js', { method: 'POST' })
      .then(res => {
        if (!res.ok) throw new Error('Failed to clear cart');
        return res.json();
      })
      .then(() => {
        const items = [];
        selectedItems.forEach(item => {
          const id  = item.getAttribute('data-variant-id');
          const qty = item.getAttribute('data-variant-qty') || 1;
          if (id && !isNaN(id)) items.push({ id: parseInt(id, 10), quantity: parseInt(qty, 10) });
        });
        if (!items.length) throw new Error('No valid items to add.');
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
      })
      .then(res => {
        if (!res.ok) return res.text().then(t => { throw new Error(t); });
        return res.json();
      })
      .then(() => {
        window.location.href = '/checkout';
      })
      .catch(err => {
        console.error('❌ Shopify error:', err.message);
        const errEl = document.querySelector('.bundle-builder__checkout-error');
        if (errEl) {
          errEl.textContent = '❌ ' + err.message;
          setTimeout(() => { errEl.textContent = ''; }, 3000);
        }
      })
      .finally(() => {
        checkoutBtn.disabled    = false;
        checkoutBtn.textContent = 'Go to checkout';
      });
  });

});
